/* eslint-disable no-shadow */
// eslint-disable-next-line no-shadow
export enum CallSource {
  NEW_CHAT = 'NEW_CHAT',
  ONGOING_CHAT = 'ONGOING_CHAT',
}

// eslint-disable-next-line no-shadow
export enum CallStatus {
  WAITING_AGENT = 'WAITING_AGENT',
  WAITING_ANSWER = 'WAITING_ANSWER',
  ONGOING = 'ONGOING',
  TERMINATED = 'TERMINATED',
  FAILED = 'FAILED',
  MISSED = 'MISSED',
  REJECTED = 'REJECTED',
}

// eslint-disable-next-line no-shadow
export enum CallDirection {
  // AGENT_INITIATED = 'AGENT_INITIATED',
  USER_INITIATED = 'USER_INITIATED',
  BUSINESS_INITIATED = 'BUSINESS_INITIATED',
}

// eslint-disable-next-line no-shadow
export enum CallPermissionResponse {
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
}

export interface CallSession {
  sdp: string;
  sdpType: 'offer' | 'answer';
}

export interface CallAgent {
  phoneNumber: string;
  whatsappPhoneNumberId: string;
}

export interface CallUser {
  phoneNumber: string;
  name: string;
  bsuid?: string;
}

export interface CallBase {
  id: string;
  chatId: string;
  status: CallStatus;
  event?: string;
  session?: CallSession;
  startedAt?: number;
  endedAt?: number;
}

export type CallIncoming = CallBase & {
  direction: CallDirection.USER_INITIATED;
  callee: CallAgent;
  caller: CallUser;
};
export type CallOutgoing = CallBase & {
  direction: CallDirection.BUSINESS_INITIATED;
  callee: CallUser;
  caller: CallAgent;
};

export type Call = CallIncoming | CallOutgoing;

export type CallLite = Pick<
  Call,
  'id' | 'event' | 'status' | 'direction' | 'session'
>;

export type CallData = {
  id: string;
  initiatedAt: string;
  merchantPhoneNumber: string;
  direction: CallDirection;
  status: CallStatus;
  source: CallSource;
  contactPhoneNumber: string;
  contactName: string;
  contactEmail: string;
  agentName: string;
  agentUsername: string;
  departmentId: number;
  departmentCode: string;
  duration: number; // in seconds
  chatViewerUrl: string;
  recordingStatus: RecordingStatus;
};

export type CallPermission = {
  name: CallPermissionNames;
  allowed: boolean;
  usage: { period: CallPermissionPediod };
};

export enum CallPermissionNames {
  SEND_CALL_PERMISSION_REQUEST = 'send_call_permission_request',
  START_CALL = 'start_call',
}

export enum CallPermissionPediod {
  PT24H = 'PT24H',
  P7D = 'P7D',
}

// eslint-disable-next-line no-shadow
export enum RecordingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}
